import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MovieService } from 'src/app/Core/services/movie.service';
import { UtilService } from 'src/app/Core/services/util.service';
import * as moment from 'moment';
import { Constant } from 'src/app/Core/services/data';
import * as _ from 'lodash';
import { param } from 'jquery';
import { TranslateService } from '@ngx-translate/core';
import { ImageProxyService } from 'src/app/Core/services/image-proxy-service';
import { PlaylistService } from 'src/app/Core/services/playlist.service';
@Component({
  selector: 'app-movieinfo',
  templateUrl: './movieinfo.component.html',
  styleUrls: ['./movieinfo.component.css']
})
export class MovieinfoComponent implements OnInit {
  public isLoading: boolean = false;
  id: string;
  movieinfo: any;
  isFavourit: boolean = false;
  favMovie: any;
  JSONDatas = [];
  movieFrom: any;
  categoryId: any;
  loadMovies:boolean = false;
  OToken:any;
  isLocal:boolean= true;
  profile_id:any;
  stream_Url: any;
  profileData:any;
  fav_id:any;
  favData:any;

  constructor(private playlistService:PlaylistService ,private imageProxyService: ImageProxyService,private translate:TranslateService,private location: Location, private router: Router, private movieService: MovieService, private utilService: UtilService,
    private route: ActivatedRoute, private toastr: ToastrService) {
    this.route.queryParams.subscribe((param: any) => {
      this.movieFrom = param.movieBy;
      console.log(param);
      this.categoryId = param.categoryId;
      this.OToken = this.utilService.getOneStreamToken();

    });
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.params['id'];
    
    // this.profileData = JSON.parse(localStorage.getItem('Profile') || '') 
    this.profileData = JSON.parse(localStorage.getItem('Profile') || '{}');

    this.getFavData()
    this.getMovieInfo(this.id);
    console.log(this.id,'id-');
    
    if (this.id) {
      let isExist: any;
      this.favMovie = JSON.parse(localStorage.getItem(Constant.MOVIES_FAV)) || [];
      const seriesId = typeof this.id === 'number' ? String(this.id) : String(this.id);
      if (this.favMovie.length > 0) {
        // isExist = _.findIndex(this.favMovie, { id:seriesId });
        isExist = _.findIndex(this.favMovie, (series: any) => String(series.id) === String(seriesId));
        if (isExist >= 0) {
          this.isFavourit = true;
        }
      }
    }
    const profileData = JSON.parse(localStorage.getItem('Profile') || '');
    const mtoken = localStorage.getItem('mtoken') || '';
    this.profile_id = profileData.profile_id;
    if(mtoken){
      this.isLocal = false;
      this.checkFav(this.profile_id);
    }else{
      this.isLocal = true;
    }
  }

    getFavData(){
    this.playlistService.getAllFavData(this.profileData.profile_id).subscribe((res:any) =>
    {
      const moviesData = res;
      this.favData = moviesData.filter( type => type.content_type == 'movie' && type.content_id == this.id);
      this.fav_id = this.favData[0].favorite_id;
      console.log(moviesData,this.favData);
    })
  }

  checkFav(id:any){
    this.playlistService.getAllFavData(id).subscribe((res:any)=>{
      console.log(res,this.id);
      const fabData = res;
      const favMovieData = fabData.filter(item => item.content_id == this.id );
      console.log(favMovieData,'fav movies data');
      if(favMovieData[0].content_id == this.id){
        this.isFavourit = true;
      }else{
       this.isFavourit = false;
      }
    })
  }

    getMovieInfo(id: any) {
    this.utilService.showSpinner()
    this.isLoading = true;
    this.movieService.getMovieDeatil(id).subscribe((res: any) => {
    this.utilService.hideSpinner()
    this.isLoading = false;
      this.movieinfo = res;
      if (this.movieinfo) {
        this.movieinfo.stream_id = this.OToken ? this.movieinfo.vod.stream_id : this.movieinfo.movie_data.stream_id;
       
        let date = moment(this.movieinfo.info.duration, 'HH:mm:ss');
        const duration: any = {
          hour: 0,
          minute: 0
        };
        duration.hour = moment(date).hour();
        duration.minute = moment(date).minute();
        this.movieinfo.info.dur = duration;
      }
    }, err => {
    this.utilService.hideSpinner()
    this.loadMovies = true
    this.isLoading = false;
      this.utilService.showErrorCall(err);
    });
    }

    loadMoviesData(){
      this.isLoading = true;
      this.movieService.getMovieDeatil(this.id).subscribe((res: any) => {
        if(res){
          this.loadMovies = false
          this.isLoading = false;
          this.movieinfo = res;
          if (this.movieinfo) {
          let date = moment(this.movieinfo.info.duration, 'HH:mm:ss');
          const duration: any = {
            hour: 0,
            minute: 0
          };
          duration.hour = moment(date).hour();
          duration.minute = moment(date).minute();
          this.movieinfo.info.dur = duration;
        }
      }
      }, err => {
      this.loadMovies = true
      this.isLoading = false;
      this.utilService.showErrorCall(err);
      });
    }

    getProxiedImageUrl(url: string): string {
      return this.imageProxyService.getProxiedImageUrl(url);
    }
  
    getMovieImageBackground(): string {
      return `url(${this.getProxiedImageUrl(this.movieinfo?.info.movie_image)}) no-repeat`;
    }

    onSave(item: any) {
      if(this.isLocal == true){

        let savedArray = [];
        let isExist: any;
        
        const msg =this.translate.instant('COMMON.ADDED_SUCCESS_MSG')
        const streamId = this.OToken ? item.vod.stream_id : item.movie_data.stream_id;
        const moviesName = this.OToken ? item.vod.name : item.movie_data.name;
        const vodLinks = this.OToken ? (item.vod.links.mkv || item.vod.links.mp4 || '')  : '';
        savedArray = JSON.parse(localStorage.getItem(Constant.MOVIES_FAV)) || [];
        if (savedArray.length > 0) {
          isExist = _.findIndex(savedArray, { id: streamId });
          if (isExist == -1) {
            item.isList = false;
            savedArray.push({ id: streamId, img: item.info.movie_image, name: moviesName,link:vodLinks, fullUrl: localStorage.getItem(Constant.FULLURL_KEY) });
            localStorage.setItem(Constant.MOVIES_FAV, JSON.stringify(savedArray));
            this.utilService.showErrorSuccess(`${msg}`);
            this.isFavourit = true;
        }
        if (isExist >= 0) {
          this.utilService.showErrorInfo('Item alreadey added to favourite')
        }

      }
      else { //first
        item.isList = false;
        this.isFavourit = true;
        savedArray.push({ id: streamId, img: item.info.movie_image, name: moviesName,link:vodLinks, fullUrl: localStorage.getItem(Constant.FULLURL_KEY) });
        localStorage.setItem(Constant.MOVIES_FAV, JSON.stringify(savedArray));
        this.utilService.showErrorSuccess(`${msg}`);
      }
    }else{
      const extension = item.movie_data.container_extension;
      this.stream_Url = this.movieService.getStremMovieUrl(item.movie_data.stream_id, extension);
      const urls = [this.stream_Url , item.info.movie_image]

      const body = {
        profile_id:this.profile_id,
        content_type: "movie",
        content_id: item.movie_data.stream_id,
        content_url: urls
      }
      
      this.playlistService.addFavorites(body).subscribe((res:any) =>{
        this.getFavData()
        this.isFavourit = true;
      })
    }
    }
    
  

  deleteFavourite(item: any) {
    console.log(item);
    
    item.id = item.stream_id;
    const msg = this.translate.instant('COMMON.REMOVE_SUCCESS_MSG')
    
    if(this.isLocal == true){
    this.utilService.deleteFavourit(Constant.MOVIES_FAV, item, (result: any) => {
      if (result) {
        this.utilService.showErrorSuccess(`${msg}`);
        this.isFavourit = false;
      }
    })}else{
      console.log(this.fav_id);
       this.playlistService.removeFavorites(this.fav_id).subscribe(res =>{
        if(res){
          this.isFavourit = false;
          this.getFavData()
        }
       })

    }
  }

  playMovies(moviesData:any){
    const streamId = this.OToken ? moviesData.vod.stream_id : moviesData.movie_data.stream_id;
    // Navigate with stream_id as part of the path
    this.router.navigate(['/movies/watch', streamId]);
  }
  
  openVlcs(moviesData:any){
    console.log(moviesData);
    const streamId = this.OToken ? moviesData.vod.links.mkv : this.movieService.getStremMovieUrl(moviesData.movie_data.stream_id, moviesData.movie_data.container_extension);
    console.log(streamId);
    this.utilService.send('start', streamId);
  }
  // playMovie(movieId) {
  //   const url = this.router.serializeUrl(
  //     this.router.createUrlTree(['/movies/watch/' + movieId])
  //   );
  //   window.open(url, '_blank');
  // }
  back(catId: any) {
    // this.location.back(); 

    if (this.movieFrom == 'search') {
      this.router.navigate(['search']);
    } else if (this.movieFrom == 'movies') {
      this.router.navigate(['/movies'], { queryParams: { category: catId } });
    } else if (this.movieFrom == 'favourites') {
      this.router.navigate(['/favourites']);
    } else {
      this.router.navigate(['/movies'], { queryParams: { category: catId } });
    }
  }
}
